import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { fetchFundDeals } from "store/state/fund";
import { downloadDeals } from "store/state/deal";
import styled from 'styled-components';
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import Paper from "@material-ui/core/Paper";
import AddAlertIcon from "@material-ui/icons/AddAlert";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import DescriptionIcon from "@material-ui/icons/Description";
import { openNotes } from "store/state/note";
import moment from "moment";
import { isEmpty } from "lodash";
import placeholder from "lib/images/featured-image-tmp.png";
import numeral from "numeral";
import { Grid } from '@material-ui/core';
import { NoItems } from 'components/Deal/DealDetailsSections/util';
import { PIPELINE, SOFT_QUOTE, DEAD, CLOSED, SOLD } from "constants/status";
import { ToastSuccess, ToastError } from "components/Global/Toasts/Toasty";
import EmptyDeals from './EmptyDeals';
import DealLabel from './DealLabel';
//Screen Preference Impoorts
import EnhancedTableHead from "components/Global/Table/EnhancedTableHead";
import BuildColumns from "components/Global/TablePreferenceColumns/BuildColumns";
import TablePaginationHelper from "../../../utils/tablePaginationHelper";
import SplashScreen from "../../LoadingIndicator/SplashScreen";

const VerticalSpacer = styled.div`
@media only screen and (max-width: 1920px) {
  height:90px;
}
@media only screen and (max-width: 1105px) {
  height:44px;
}
  width:100%;
`

const getTableContactSettingIdForStatus = status => {
  switch (status) {
    case PIPELINE:
      return "7c3d1c4d-a7a2-4fa0-b096-78087b6b976b";
    case DEAD:
      return "c57f74f9-6a21-4710-bdf6-5d0447120d60";
    case CLOSED:
      return "e673e6c4-1a5d-4411-a1ab-d35e9d2d9c82";
    case SOLD:
      return "f0fced4c-96b0-403c-a88f-84c223300aeb";
    default:
      return undefined;
  }
};

class DealsList extends React.Component {
  state = {
    orderDir: "asc",
    orderBy: "createdAt",
    selected: []
  };

  columns = [];
  componentDidMount() {
    const tablePaginationHelper = new TablePaginationHelper(getTableContactSettingIdForStatus(this.props.status[0]), 10, this.props.funds.id);

    const { funds, status,screenType } = this.props;    
    this.props.fetchFundDeals({
      page: tablePaginationHelper.page,
      limit: tablePaginationHelper.rowsPerPage,
      fundId: funds.id,
      status,
      screenType
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const tablePaginationHelper = new TablePaginationHelper(getTableContactSettingIdForStatus(this.props.status[0]), 10, this.props.funds.id);

    const { funds, status,screenType, screenPreferenceList } = this.props;
    const { screenPreferenceList: prevScreenPreferenceList} = prevProps;

    if((prevProps.funds.id !== funds.id) || (screenPreferenceList !== prevScreenPreferenceList)){
      this.props.fetchFundDeals({
        page: tablePaginationHelper.page,
        limit: tablePaginationHelper.rowsPerPage,
        fundId: funds.id,
        status,
        screenType
      });
    }
  }

  dealLink = (statusId, dealId) => {
    switch (statusId) {
      case PIPELINE:
        return `/pipeline/active/deals/${dealId}`;
      case SOFT_QUOTE:
        return `/pipeline/softquote/deals/${dealId}`;
      case DEAD:
        return `/pipeline/dead/deals/${dealId}`;
      default:
        return `/deals/${dealId}`;
    }
  };

  getRows = (deals, order, status) => {
    let pathFunction = this.props.pathFunction;
    return order.map(key => (
      <TableRow key={key} hover>
        {this.columns.map(({ id, Cell }) => (
          <Cell key={id} deal={deals[key]} linkPath={pathFunction}/>
        ))}
      </TableRow>
    ));
  }

  formatCurrencyHelper = value => {
    if (!value) return null;
    return numeral(value).format("$0,0");
  };

  formatPercentageHelper = value => {
    if (!value) return null;
    return numeral(value).format("0.000%");
  };

  formatTableLabel = statuses => {
    const status = statuses[0];
    switch (status) {
      case PIPELINE:
        return { upper: "PIPELINE DEALS", lower: "Pipeline Deals" };
      case DEAD:
        return { upper: "DEAD DEALS", lower: "Dead Deals" };
      case CLOSED:
        return { upper: "CLOSED DEALS", lower: "Closed Deals" };
      case SOLD:
        return { upper: "SOLD DEALS", lower: "Sold Deals" };
    }
  };
  handleTableExport = () => {  
    const {funds} = this.props;  
    this.props.downloadDeals({ 
      statusId: this.props.status,
      fundId: funds.id,
      screenType: this.props.screenType });
  };
  render() {    
    const tablePaginationHelper = new TablePaginationHelper(getTableContactSettingIdForStatus(this.props.status[0]), 10, this.props.funds.id);
    const rowsPerPage = tablePaginationHelper.rowsPerPage;
    const page = tablePaginationHelper.page;
    const { orderDir, orderBy, selected } = this.state;    
    const { funds, status } = this.props;
    const {
      fund: { deals }
    } = this.props;

    if (isEmpty(funds)) {
      return <SplashScreen loading={ true}/>;
    }

    if (isEmpty(deals[status])) {
      return <SplashScreen loading={ true}/>;
    }
    
    BuildColumns(
      this.props.screenPreferenceList,
      this.props.TableScreenElements,
      this.columns
    );

    if (this.columns.length > 0) {
      return (
        <Fragment>
          {Object.keys(deals[status].deals).length > 0 ? (
            <Paper
              elevation={0}
              style={{ backgroundColor: "transparent", margin: "10px" }}
            >
              <div
                className="tableOuterHeader sub-title-component"
              >
                {this.formatTableLabel(status).lower}
              </div>
              {deals[status].deals ? (
                <Table className="loansList_Table _tableClosedDealList" id="closedDealList">
                  <EnhancedTableHead
                    numSelected={selected.length}
                    order={orderDir}
                    orderBy={orderBy}
                    onRequestSort={this.handleRequestSort}
                    rowCount={deals[status].count}
                    columns={this.columns}
                    metrics={this.props.screenPreferenceList}
                    screenType={this.props.screenType}
                    onClose={() => {
                      this.columns = [];
                    }}
                    exportTable={this.handleTableExport}
                  />
                  <TableBody>
                    {this.getRows(
                      deals[status].deals,
                      deals[status].order,
                      status
                    )}
                  </TableBody>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        colSpan={10}
                        count={deals[status].count}
                        rowsPerPage={rowsPerPage}
                        rowsPerPageOptions={[5, 10, 25, 100]}
                        page={page}
                        backIconButtonProps={{
                          "aria-label": "Previous Page"
                        }}
                        nextIconButtonProps={{
                          "aria-label": "Next Page"
                        }}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        labelDisplayedRows={() => `${page + 1} of ${Math.ceil(deals[status].count / rowsPerPage)}`}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              ) : (
                <div>Loading</div>
              )}
            </Paper>
          ) : (
            <Fragment>
              <DealLabel status={status} />
              <EmptyDeals status={status} />              
            </Fragment>
          )}
        </Fragment>
      );
    }
    return <SplashScreen loading={ true}/>;
  }

  // BEGIN: Table Controls

  handleRequestSort = (event, property) => {    
    const {screenType} = this.props;
    const orderBy = property.dataField;    
    if (orderBy) {
      const { funds, status } = this.props;
      let order = "desc";      
      if (this.state.orderBy === orderBy && this.state.orderDir === "desc") {
        order = "asc";
      }      

      const tablePaginationHelper = new TablePaginationHelper(getTableContactSettingIdForStatus(this.props.status[0]), 10, this.props.funds.id);

      tablePaginationHelper.page = 0;
      this.setState({ orderDir: order.toLowerCase(), orderBy });
      this.props.fetchFundDeals({
        page: tablePaginationHelper.page,
        limit: tablePaginationHelper.rowsPerPage,
        orderField: orderBy,
        orderDir: order,
        fundId: funds.id,
        status,
        screenType
      });
    }
  };

  handleClick = (event, id) => {    
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangePage = (event, newPage) => {
    const { funds, status, screenType } = this.props;
    if (!event) {
      return null;
    }
    const tablePaginationHelper = new TablePaginationHelper(getTableContactSettingIdForStatus(this.props.status[0]), 10, this.props.funds.id);
    tablePaginationHelper.page = newPage;
    this.props.fetchFundDeals({
      page: tablePaginationHelper.page,
      limit: tablePaginationHelper.rowsPerPage,
      orderField: this.state.orderBy,
      orderDir: this.state.orderDir,
      fundId: funds.id,
      status,
      screenType
    });
  };

  handleChangeRowsPerPage = event => {
    const { funds, status, screenType } = this.props;
    const tablePaginationHelper = new TablePaginationHelper(getTableContactSettingIdForStatus(this.props.status[0]), 10, this.props.funds.id);
    tablePaginationHelper.rowsPerPage = event.target.value;

    this.props.fetchFundDeals({
      page: tablePaginationHelper.page,
      limit: tablePaginationHelper.rowsPerPage,
      orderField: this.state.orderBy,
      orderDir: this.state.orderDir,
      fundId: funds.id,
      status,
      screenType
    });
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  // END: Table Controls

  notify = (notifyState, reason) =>
    ToastError(
      <Fragment>
        <strong>{notifyState}</strong> has been {reason}
      </Fragment>
    );
}

const mapStateToProps = ({ fund, deal }) => ({
  fund,
  deal
});

export default connect(
  mapStateToProps,
  { openNotes, fetchFundDeals, downloadDeals }
)(DealsList);
